/**
 * `/sales/proformas/new` - create a draft proforma (ADR-0032).
 *
 * Uses the same full-bleed editor shell as `/sales/invoices/new`; the
 * composer owns the 2-column form + live preview layout.
 *
 * @see prototype/sales/invoice-new.html - V1.1 baseline reused for proformas.
 * @see docs/adr/0032-proforma-invoices.md - non-fiscal proforma lifecycle.
 */
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { hasPermission } from "@flint/api-contract";
import { Alert } from "@flint/ui";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { ProformaComposerPage } from "../../../../features/proformas/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/sales/proformas/new")({
  component: NewProformaRoute,
});

function NewProformaRoute() {
  const me = useQuery(meQueryOptions);
  const canCreate = hasPermission(me.data?.company?.permissions ?? [], "invoices.create");

  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sales" },
        { label: "Proformas", to: "/sales/proformas" },
        { label: "New proforma" },
      ]}
      viewportClassName="!p-0"
      contentClassName="max-w-none"
    >
      {me.isLoading ? (
        <div className="p-6 text-sm text-muted">Checking proforma permissions...</div>
      ) : canCreate ? (
        <ProformaComposerPage />
      ) : (
        <div className="mx-auto max-w-3xl p-6">
          <Alert
            intent="bad"
            title="You don't have permission to create proformas"
            description="Ask an Owner or Admin to grant invoice draft access."
          />
        </div>
      )}
    </WorkspaceShell>
  );
}
